import { Injectable, inject } from '@angular/core';
import { Firestore, collection, getCountFromServer, query, orderBy, limit, collectionData } from '@angular/fire/firestore';
import { firstValueFrom, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AnaliticService {

  private firestore = inject(Firestore);

  getOrderCount(userId: string, appId: string): Promise<number> {
    const ordersRef = collection(this.firestore, `Users/${userId}/Apps/${appId}/Orders`);
    return getCountFromServer(ordersRef).then(snapshot => snapshot.data().count);
  }

  getProductCount(userId: string, appId: string): Promise<number> {
    const productsRef = collection(this.firestore, `Users/${userId}/Apps/${appId}/Products`);
    return getCountFromServer(productsRef).then(snapshot => snapshot.data().count);
  }

  getTopViewedProductsLive(userId: string, appId: string, limitCount: number = 5): Observable<any[]> {
    const path = `Users/${userId}/Apps/${appId}/Products`;
    console.log('📦 Realtime path:', path);
    const productsRef = collection(this.firestore, path);
  
    return collectionData(productsRef, { idField: 'id' }).pipe(
      map((data: any[]) => {
        const sorted = data.sort((a, b) => (b.views ?? 0) - (a.views ?? 0));
        const limited = sorted.slice(0, limitCount);
        console.log('🔁 Realtime sorted data:', limited);
        return limited;
      })
    );
  }
}
